export default __webpack_public_path__ + "static/media/arrow-left-dark.641906d2.svg";